/**
 * "41m", "1h 06m", "24d 11h" — the design's wait format, with a day above a day.
 *
 * It used to count hours for ever. A payout raised in early September read
 * "Requested 587h 27m ago", which is twenty-four days written in a unit nobody
 * converts in their head — and the SLA it is measured against is two hours, so
 * the hours were carrying no information by then either. Minutes are dropped
 * once it is days: nobody reading "24d" needs the 27.
 *
 * The threshold is 24h rather than 48h or a week because the useful reading
 * changes there — under a day an operator thinks in hours, over it they think
 * in days.
 *
 * Shared since the dashboard's queue pills printed "oldest 56379m" (staging, 15 Oct): the
 * withdrawals queue, the dashboard and Live operations say a wait one way.
 */
export function formatWait(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  if (minutes < 1440) {
    return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, '0')}m`;
  }
  const days = Math.floor(minutes / 1440);
  return `${days}d ${Math.floor((minutes % 1440) / 60)}h`;
}
